<template>
  <div>
    <es-loader
      v-if="loading"
      style="margin: 4.5rem"
    />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="1rem"
      style="padding: 5rem"
    />
    <div v-else class="document">
      <div
        class="header"
        style="display: flex"
      >
        <EsHeader>
          <template #header>
            <div class="header-title">
              Add Location ({{ mapPersonType(currentLocationPersonType) }})
            </div>
          </template>
        </EsHeader>
      </div>
      <es-form
        style="margin-right: 0rem;"
      >
        <template #es-form>
          <div
            class="content"
            style="padding: 1rem 0"
          >
            <div class="columns">
              <div class="column main-column">
                <div
                  v-if="fieldEnabled('SCHOOL_YEAR')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('SCHOOL_YEAR') }}
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${year}"
                            :setValues="schoolYears"
                            keyValue="id"
                            v-on:update:values="schoolYear = $event;
                              validateSelectField('schoolYear')"
                            :disabled="allowedSchoolYear === 'Current Year Only'"
                            :hasError="hasErrorSchoolYear"
                            :errorMsg="msgSchoolYear"
                            :preSelected="preSelectedschoolYear"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('DISTRICT_CODE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('DISTRICT_CODE') }}
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            :search="true"
                            api="districts"
                            v-on:update:values="districtCode = $event;
                              validateSelectField('districtCode')"
                            :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                            searchMinLength="3"
                            keyValue="code"
                            :hasError="hasErrorDistrict"
                            :errorMsg="msgDistrict"
                            :preSelected="districtCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('SCHOOL_CODE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('SCHOOL_CODE') }}
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            :disabled="!districtCode.length"
                            v-bind:search="true"
                            api="schools"
                            :apiQueryParams="getDistrictParams"
                            v-on:update:values="schoolCode = $event;
                              validateSelectField('schoolCode')"
                            :valueTplFn="(result) =>
                              `${result.location.name} (${result.code})`"
                            :subValueTplFn="(result) =>
                              `${result.districtLocation.name}
                                (<i>${result.districtCode}</i>)`"
                            searchMinLength="3"
                            keyValue="code"
                            :hasError="hasErrorSchool"
                            :errorMsg="msgSchool"
                            :preSelected="schoolCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('RES_DISTRICT_CODE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('RES_DISTRICT_CODE') }}
                        <span
                          v-if="!fieldRequired('RES_DISTRICT_CODE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            :search="true"
                            api="districts"
                            v-on:update:values="resDistrictCode = $event;
                              validateSelectField('resDistrictCode')"
                            :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                            :apiQueryParams="getAll"
                            searchMinLength="3"
                            keyValue="code"
                            :hasError="hasErrorResDistrict"
                            :errorMsg="msgResDistrict"
                            :preSelected="resDistrictCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('LOCAL_STUDENT_ID')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label"
                        for="localIdInputAddPersonLocationForm">
                        {{ fieldLabel('LOCAL_STUDENT_ID') }}
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                           <input
                            class="input"
                            :class="{ 'is-danger': hasErrorLocalId }"
                            type="text"
                            v-model="localId"
                            @keyup.prevent="validateInputField('localId')"
                            @paste="onPasteValidation('localId')"
                            id="localIdInputAddPersonLocationForm"
                            :title="localId"
                          />
                        </div>
                        <span
                          v-if="hasErrorLocalId"
                          class="help is-danger"
                        >
                          {{ msgLocalId }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('SOURCE_CODE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('SOURCE_CODE') }}
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeSources"
                            keyValue="code"
                            v-on:update:values="sourceCode = $event;
                              validateSelectField('sourceCode')"
                            :clearOut="true"
                            :hasError="hasErrorSource"
                            :errorMsg="msgSource"
                            :preSelected="sourceCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('ALT_STUDENT_ID')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label" for="altIdInputAddPersonLocationForm">
                        {{ fieldLabel('ALT_STUDENT_ID') }}
                        <span
                          v-if="!fieldRequired('ALT_STUDENT_ID')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            class="input"
                            :class="{ 'is-danger': hasErrorAltPersonId }"
                            type="text"
                            v-model="altPersonId"
                            @keyup.prevent="validateInputField('altPersonId');
                              validateAltIDAndAltSourceLinkage()"
                            @paste="handlePaste"
                            id="altIdInputAddPersonLocationForm"
                            :title="altPersonId"
                          />
                        </div>
                        <span
                          v-if="hasErrorAltPersonId"
                          class="help is-danger"
                        >
                          {{ msgAltPersonId }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('ALT_SOURCE_SIS_CODE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('ALT_SOURCE_SIS_CODE') }}
                        <span
                          v-if="!fieldRequired('ALT_SOURCE_SIS_CODE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeSources"
                            keyValue="code"
                            v-on:update:values="altSourceCode = $event;
                              validateSelectField('altSourceCode')
                              validateAltIDAndAltSourceLinkage()"
                            :clearOut="true"
                            :hasError="hasErrorAltSource"
                            :errorMsg="msgAltSource"
                            :preSelected="altSourceCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('ACTIVE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('ACTIVE') }}
                        <span
                          v-if="!fieldRequired('ACTIVE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeStatusOptions"
                            keyValue="code"
                            v-on:update:values="active = $event;
                              validateSelectField('active')"
                            :clearOut="true"
                            :hasError="hasErrorActive"
                            :errorMsg="msgActive"
                            :preSelected="active"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('SOURCE_REFRESH_DATE')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label"
                        for="sourceRefreshDateInputAddPersonLocationForm">
                        {{ fieldLabel('SOURCE_REFRESH_DATE') }}
                        <span
                          v-if="!fieldRequired('SOURCE_REFRESH_DATE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            :class="{ 'is-danger': hasErrorSourceRefreshDate }"
                            class="input calendar"
                            type="date"
                            v-model="sourceRefreshDate"
                            @change.prevent="validateDateField('sourceRefreshDate')"
                            id="sourceRefreshDateInputAddPersonLocationForm"
                            :title="sourceRefreshDate"
                          />
                        </div>
                        <span
                          v-if="hasErrorSourceRefreshDate"
                          class="help is-danger"
                        >
                          {{ msgSourceRefreshDate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('LOCATION_COMMENT')"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label"
                        for="commentControlAddPersonLocationForm">
                        {{ fieldLabel('LOCATION_COMMENT') }}
                        <span
                          v-if="!fieldRequired('LOCATION_COMMENT')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <textarea
                            style="width: 100%; resize: none"
                            :class="{ 'border-red': hasErrorLocationComment }"
                            rows="3"
                            v-model="locationComment"
                            @keyup.prevent="validateInputField('locationComment')"
                            @paste="onPasteValidation('locationComment')"
                            id="commentControlAddPersonLocationForm"
                          ></textarea>
                        </div>
                        <span
                          v-if="hasErrorLocationComment"
                          class="help is-danger"
                        >
                          {{ msgLocationComment }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column main-column">
                <div
                  v-if="fieldEnabled('GRADE_CODE')
                    && currentPersonTypeCategory === 'STUDENT'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('GRADE_CODE') }}
                        <span
                          v-if="!fieldRequired('GRADE_CODE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeGrades"
                            keyValue="code"
                            v-on:update:values="gradeCode = $event;
                              validateField('gradeCode')"
                            :clearOut="true"
                            :hasError="hasErrorGrade"
                            :errorMsg="msgGrade"
                            :preSelected="gradeCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('HIRE_DATE')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label"
                        for="hireDateInputAddPersonLocationForm">
                        {{ fieldLabel('HIRE_DATE') }}
                        <span
                          v-if="!fieldRequired('HIRE_DATE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            class="input calendar"
                            type="date"
                            :class="{ 'is-danger': hasErrorHireDate }"
                            v-model="hireDate"
                            @change.prevent="validateDateField('hireDate')"
                            id="hireDateInputAddPersonLocationForm"
                            :title="hireDate"
                          />
                        </div>
                        <span
                          v-if="hasErrorHireDate"
                          class="help is-danger"
                        >
                          {{ msgHireDate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('SALARY')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label"
                        for="salaryInputAddPersonLocationForm">
                        {{ fieldLabel('SALARY') }}
                        <span
                          v-if="!fieldRequired('SALARY')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <input
                            class="input"
                            :class="{ 'is-danger': hasErrorSalary }"
                            type="text"
                            @blur="annSalaryFocusOut"
                            @focus="annSalaryFocusIn"
                            v-model="salary"
                            @keyup.prevent="validateField('salary')"
                            @keypress="isFloatNumbers($event)"
                            id="salaryInputAddPersonLocationForm"
                            :title="salary"
                          />
                        </div>
                        <span
                          v-if="hasErrorSalary"
                          class="help is-danger"
                        >
                          {{ msgSalary }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('JOB_CLASS_CODE')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('JOB_CLASS_CODE') }}
                        <span
                          v-if="!fieldRequired('JOB_CLASS_CODE')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeTitles"
                            keyValue="code"
                            v-on:update:values="jobClassCode = $event;
                              validateSelectField('jobClassCode')"
                            :clearOut="true"
                            :hasError="hasErrorJobClass"
                            :errorMsg="msgJobClass"
                            :preSelected="jobClassCode"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('JOB_ASSIGNMENT_1')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('JOB_ASSIGNMENT_1') }}
                        <span
                          v-if="!fieldRequired('JOB_ASSIGNMENT_1')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeJobAssignments"
                            keyValue="code"
                            v-on:update:values="jobAssignment1 = $event;
                              validateSelectField('jobAssignment1')"
                            :clearOut="true"
                            :hasError="hasErrorJobAssign1"
                            :errorMsg="msgJobAssign1"
                            :preSelected="jobAssignment1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('JOB_ASSIGNMENT_2')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('JOB_ASSIGNMENT_2') }}
                        <span
                          v-if="!fieldRequired('JOB_ASSIGNMENT_2')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeJobAssignments"
                            keyValue="code"
                            v-on:update:values="jobAssignment2 = $event;
                              validateSelectField('jobAssignment2')"
                            :clearOut="true"
                            :hasError="hasErrorJobAssign2"
                            :errorMsg="msgJobAssign2"
                            :preSelected="jobAssignment2"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('JOB_ASSIGNMENT_3')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('JOB_ASSIGNMENT_3') }}
                        <span
                          v-if="!fieldRequired('JOB_ASSIGNMENT_3')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeJobAssignments"
                            keyValue="code"
                            v-on:update:values="jobAssignment3 = $event;
                              validateSelectField('jobAssignment3')"
                            :clearOut="true"
                            :hasError="hasErrorJobAssign3"
                            :errorMsg="msgJobAssign3"
                            :preSelected="jobAssignment3"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fieldEnabled('ITINERANT_FLAG')
                    && currentPersonTypeCategory === 'EMPLOYEE'"
                  class="row"
                >
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">
                        {{ fieldLabel('ITINERANT_FLAG') }}
                        <span
                          v-if="!fieldRequired('ITINERANT_FLAG')"
                          class="label-optional has-text-grey-light"
                        >
                          &nbsp;(optional)
                        </span>
                      </label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <es-select
                            valueTpl="${description}"
                            :setValues="activeItinerantFlags"
                            keyValue="code"
                            v-on:update:values="itinerantFlag = $event;
                              validateSelectField('itinerantFlag')"
                            :clearOut="true"
                            :hasError="hasErrorItinerantFlag"
                            :errorMsg="msgItinerantFlag"
                            :preSelected="itinerantFlag"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-form>
      <div
        class="is-flex flex-justify--end flex-align--center action-buttons"
        style="margin-right: 5.15rem; padding-bottom: 2rem"
      >
        <router-link
          style="margin-right: 1rem"
          :to="{
            name: 'PidMasterRecord',
            query: {
              retired: isRetired,
            },
          }"
        >
          Cancel
        </router-link>
        <button
          class="button is-primary"
          @click.prevent="addLocation()"
        >
          Add Location
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faEdit,
} from '@fortawesome/pro-regular-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsSelect from '@/components/EsSelect.vue';
import DateUtils from '@/mixins/DateUtils';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import SchoolYearsAllowed from '@/mixins/SchoolYearsAllowed';

library.add(
  faAngleDoubleLeft,
  faEdit,
);

export default {
  mixins: [
    DateUtils,
    FieldLabels,
    NotificationManager,
    SchoolYearsAllowed,
  ],
  components: {
    EsException,
    EsForm,
    EsHeader,
    EsLoader,
    EsSelect,
  },
  props: {
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  data() {
    const errorFields = [
      'SchoolYear', 'District', 'School', 'ResDistrict', 'Source', 'LocalId',
      'AltSource', 'AltPersonId', 'Active', 'SourceRefreshDate', 'LocationComment',
      'Grade', 'HireDate', 'Salary', 'JobClass', 'JobAssign1', 'JobAssign2',
      'JobAssign3', 'ItinerantFlag',
    ];

    const data = {
      active: [],
      activeStatusOptions: [],
      altPersonId: null,
      altSourceCode: [],
      districtCode: [],
      gradeCode: [],
      hireDate: null,
      itinerantFlag: [],
      jobAssignment1: [],
      jobAssignment2: [],
      jobAssignment3: [],
      jobClassCode: [],
      loading: false,
      loadingError: false,
      localId: null,
      locationComment: null,
      resDistrictCode: [],
      salary: null,
      schoolCode: [],
      schoolYear: [],
      sourceCode: [],
      sourceRefreshDate: null,
    };

    // Dynamically add `hasError` and `msg` to error fields
    errorFields.forEach((field) => {
      data[`hasError${field}`] = false;
      data[`msg${field}`] = null;
    });

    return data;
  },
  created() {
    this.onLoad();
    this.setElements();
  },
  computed: {
    ...mapGetters(['userPersonTypes']),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeGrades',
      'activeItinerantFlags',
      'activeJobAssignments',
      'activePersonTypes',
      'activeSources',
      'activeTitles',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
      'getFieldLengthsByPersonType',
      'getFieldEnabledForPersonType',
      'getFieldRequiredForPersonType',
    ]),
    allowedSchoolYear() {
      return this.$store.state.propertiesModule.properties['RULE-SCHOOL_YEARS_ALLOWED'];
    },
    currentPersonTypeCategory() {
      return this.userPersonTypes.find(r => r.code === this.currentLocationPersonType).category;
    },
    currentLocationPersonType() {
      return this.$route.query.personType;
    },
    currentSchoolYear() {
      return this.$store.state.propertiesModule.properties['RULE-CURRENT_SCHOOL_YEAR'];
    },
    getAll() {
      return {
        allDistricts: true,
      };
    },
    getDistrictParams() {
      const params = {};
      params.districtCode = this.districtCode.map(d => d.code);
      return params;
    },
    masterRecordTab() {
      if (this.$route.path.includes('/masterRecord')) {
        return true;
      }
      return false;
    },
    payLoad() {
      const temp = {};
      if (this.schoolYear.length) {
        temp.schoolYear = this.schoolYear[0].year;
      }
      if (this.districtCode.length) {
        temp.districtCode = this.districtCode[0].code;
      }
      if (this.districtCode.length) {
        temp.districtCode = this.districtCode[0].code;
      }
      if (this.schoolCode.length) {
        temp.schoolCode = this.schoolCode[0].code;
      }
      if (this.resDistrictCode.length) {
        temp.resDistrictCode = this.resDistrictCode[0].code;
      }
      if (this.person.stateStudentId) {
        temp.personId = this.person.stateStudentId;
      }
      if (this.localId) {
        temp.localId = this.localId;
      }
      if (this.sourceCode.length) {
        temp.sourceCode = this.sourceCode[0].code;
      }
      if (this.altPersonId) {
        temp.altPersonId = this.altPersonId;
      }
      if (this.altSourceCode.length) {
        temp.altSourceCode = this.altSourceCode[0].code;
      }
      if (this.currentLocationPersonType) {
        temp.personType = this.currentLocationPersonType;
      }
      if (this.active.length) {
        temp.active = this.active[0].code;
      }
      if (this.sourceRefreshDate) {
        temp.sourceRefreshDate = this.sourceRefreshDate;
      }
      if (this.locationComment) {
        temp.locationComment = this.locationComment;
      }
      if (this.currentPersonTypeCategory === 'STUDENT') {
        if (this.gradeCode.length) {
          temp.gradeCode = this.gradeCode[0].code;
        }
      } else if (this.currentPersonTypeCategory === 'EMPLOYEE') {
        if (this.hireDate) {
          temp.hireDate = this.hireDate;
        }
        if (this.jobClassCode.length) {
          temp.jobClassCode = this.jobClassCode[0].code;
        }
        if (this.jobAssignment1.length) {
          temp.jobAssignment1 = this.jobAssignment1[0].code;
        }
        if (this.jobAssignment2.length) {
          temp.jobAssignment2 = this.jobAssignment2[0].code;
        }
        if (this.jobAssignment3.length) {
          temp.jobAssignment3 = this.jobAssignment3[0].code;
        }
        if (this.itinerantFlag.length) {
          temp.itinerantFlag = this.itinerantFlag[0].code;
        }
        if (this.salary) {
          temp.salary = this.salary;
        }
      }
      return temp;
    },
    preSelectedschoolYear() {
      return [this.schoolYears.find(a => a.year === this.currentSchoolYear)];
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
      'loadGrades',
      'loadSources',
      'loadJobAssignments',
      'loadTitles',
      'loadPidSchoolYears',
    ]),
    async addLocation() {
      if (this.checkFieldValidations() || this.validateAltIDAndAltSourceLinkage()) {
        this.showNotification('danger', ['There were some errors.Please fix the errors highlighted in the fields below.']);
        return;
      }
      try {
        this.hideNotification();
        this.loading = true;
        const response = await axios.post(`/person/${this.person.stateStudentId}/location`, this.payLoad);

        if (response.status === 200) {
          sessionStorage.setItem('notificationsLocation', JSON.stringify({
            type: 'success',
            message: ['The location has been added successfully.'],
          }));

          // Execute only if API succeeds
          this.$root.$emit('reloadPerson');
          this.$router.push({
            name: 'PidMasterLocationInfoDetails',
            query: {
              districtCode: this.payLoad.districtCode,
              schoolCode: this.payLoad.schoolCode,
              personType: this.payLoad.personType,
              retired: this.$route.query.retired === true || this.$route.query.retired === 'true',
            },
          });
        }
      } catch (error) {
        let errorMessage = 'There was an issue. Please try again or contact your administrator.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.showNotification('danger', [errorMessage]);
        console.error(error);
        this.loadingError = true;
      } finally {
        this.loading = false; // Ensure loading is reset regardless of success or failure
      }
    },
    annSalaryFocusIn() {
      if (this.salaryTemporary !== null) {
        // Unformat  Salary value before user starts modifying it
        this.initialInfo.salary = this.salaryTemporary.toString();
      }
    },
    annSalaryFocusOut() {
      if (this.initialInfo.salary !== null) {
        // Recalculate the  Salary after ignoring the digits and "." in user input
                this.salaryTemporary = parseFloat(this.initialInfo.salary.replace(/[^\d\.]/g, "")); // eslint-disable-line
      }
      if (Number.isNaN(this.salaryTemporary)) {
        // Ensure that value is not NaN. If so, initialize it to 'this.initialInfo.salary (NULL)'.
        // This happens if user provides a blank input
        this.salaryTemporary = this.initialInfo.salary;
      }
      if (this.salaryTemporary !== null) {
        // Format display value based on calculated  Salary
        this.initialInfo.salary = this.salaryTemporary.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.,\d+)?$)/g, '$1,');
      }
    },
    anyFieldsEnabled(fieldNames) {
      // check whether any field is enabled
      const items = fieldNames.filter(fn => this.getFieldEnabledForPersonType(fn, 'ASSIGN', this.record.personType));
      return (items && items.length > 0);
    },
    checkFieldValidations() {
      const selectFields = [
        'schoolYear', 'districtCode', 'schoolCode', 'resDistrictCode', 'sourceCode',
        'altSourceCode', 'active',
      ];
      const inputFields = ['localId', 'altPersonId', 'locationComment'];
      const dateFields = ['sourceRefreshDate'];

      selectFields.forEach(field => this.validateSelectField(field));
      inputFields.forEach(field => this.validateInputField(field));
      dateFields.forEach(field => this.validateDateField(field));

      if (this.currentPersonTypeCategory === 'STUDENT') {
        this.validateSelectField('gradeCode');
      }

      if (this.currentPersonTypeCategory === 'EMPLOYEE') {
        const employeeSelectFields = [
          'jobClassCode', 'jobAssignment1', 'jobAssignment2',
          'jobAssignment3', 'itinerantFlag',
        ];

        employeeSelectFields.forEach(field => this.validateSelectField(field));

        this.validateDateField('hireDate');
        this.validateField('salary');
      }

      // Check if there are any validation errors
      const errorFields = [
        'hasErrorSchoolYear', 'hasErrorDistrict', 'hasErrorSchool',
        'hasErrorResDistrict', 'hasErrorSource', 'hasErrorLocalId',
        'hasErrorAltPersonId', 'hasErrorAltSource', 'hasErrorActive',
        'hasErrorSourceRefreshDate', 'hasErrorLocationComment',
        'hasErrorGrade', 'hasErrorHireDate', 'hasErrorSalary',
        'hasErrorJobClass', 'hasErrorJobAssign1', 'hasErrorJobAssign2',
        'hasErrorJobAssign3', 'hasErrorItinerantFlag',
      ];

      const error = errorFields.some(field => this[field]);

      // Display notification based on error
      if (error) {
        this.showNotification('danger', ['There were some errors. Please fix the errors highlighted in the fields below.']);
      } else {
        this.resetNotifications();
      }

      return error;
    },
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, 'ASSIGN', this.currentLocationPersonType);
    },
    fieldLength(code) {
      return this.getFieldLengthsByPersonType(code, 'ASSIGN', this.currentLocationPersonType);
    },
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.currentLocationPersonType);
    },
    fieldRequired(code) {
      return this.getFieldRequiredForPersonType(code, 'ASSIGN', this.currentLocationPersonType);
    },
    handlePaste() {
      // Optionally, let Vue update the model first
      this.$nextTick(() => {
        this.validateInputField('altPersonId');
        this.validateAltIDAndAltSourceLinkage();
      });
    },
    hideDetailsPanel() {
      this.$emit('hideDetails');
    },
    isFloatNumbers(evt) {
      // Listen to the key event when a keyboard key is pressed
      evt = (evt) || window.event; // eslint-disable-line
      // Store the ASCII value of the pressed key in 'charCode'
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      // Prevent user from entering any values except digits and '.'
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      }
    },
    mapGrades(code) {
      if (code) {
        return this.activeGrades.find(g => g.code === code).description;
      }
      return '\u00A0';
    },
    mapPersonType(personType) {
      return this.activePersonTypes.find(r => r.code === personType).name;
    },
    async onLoad() {
      this.loading = true;
      this.loadingError = false;

      const loadFunctions = [
        this.loadGrades(),
        this.loadPersonTypes(),
        this.loadSources(),
        this.loadJobAssignments(),
        this.loadTitles(),
        this.loadPidSchoolYears(),
      ];

      try {
        await Promise.all(loadFunctions);
      } catch (error) {
        this.loadingError = true;
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    onPasteValidation(fieldName) {
      // Run validation after paste completes
      this.$nextTick(() => {
        this.validateInputField(fieldName);
      });
    },
    resetNotifications() {
      this.hideNotification();
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    setElements() {
      this.schoolYear = [this.schoolYears.find(a => a.year === this.currentSchoolYear)];
      this.activeStatusOptions = [
        { code: false, description: 'Inactive' },
        { code: true, description: 'Active' },
      ];
    },
    validateField(field) {
      if (field === 'salary') {
        if (this.fieldRequired('SALARY') && !this.salary) {
          this.hasErrorSalary = true;
          this.msgSalary = `${this.fieldLabel('SALARY')} is required.`;
        } else if (this.salary && this.salary.split('.')[0].length > this.fieldLength('SALARY')) {
          this.hasErrorSalary = true;
          this.msgSalary = `${this.fieldLabel('SALARY')} exceeds character limit 10.2`;
        } else {
          this.hasErrorSalary = false;
          this.msgSalary = null;
        }
      }
    },
    validateDateField(field) {
      const Obj = {
        sourceRefreshDate: ['SOURCE_REFRESH_DATE', 'hasErrorSourceRefreshDate', 'msgSourceRefreshDate'],
        hireDate: ['HIRE_DATE', 'hasErrorHireDate', 'msgHireDate'],
      };
      if (Object.keys(Obj).includes(field)) {
        const [code, hasError, msg] = Obj[field];
        if (this.fieldRequired(code) && !this[field]) {
          this[hasError] = true;
          this[msg] = `${this.fieldLabel(code)} is required.`;
        } else if (this[field] && !this.isValidDateFormat(this[field], 'YYYY-MM-DD')) {
          this[hasError] = true;
          this[msg] = `${this.fieldLabel(code)} is invalid.`;
        } else {
          this[hasError] = false;
          this[msg] = null;
        }
      }
    },
    validateInputField(field) {
      const makeField = (code, hasErrorKey, msgKey) => [
        code, hasErrorKey, msgKey, this.fieldLength(code),
      ];

      const Obj = {
        localId: makeField('LOCAL_STUDENT_ID', 'hasErrorLocalId', 'msgLocalId'),
        altPersonId: makeField('ALT_STUDENT_ID', 'hasErrorAltPersonId', 'msgAltPersonId'),
        locationComment: makeField('LOCATION_COMMENT', 'hasErrorLocationComment', 'msgLocationComment'),
      };

      if (Object.keys(Obj).includes(field)) {
        const [code, hasError, msg, maxLength] = Obj[field];
        if (this.fieldRequired(code) && !this[field]) {
          this[hasError] = true;
          this[msg] = `${this.fieldLabel(code)} is required.`;
        } else if (this[field] && this[field].length > maxLength) {
          this[hasError] = true;
          this[msg] = `${this.fieldLabel(code)} allows a maximum of ${maxLength} characters.`;
        } else {
          this[hasError] = false;
          this[msg] = null;
        }
      }
    },
    validateSelectField(field) {
      const ObjEsSelect = {
        districtCode: ['DISTRICT_CODE', 'hasErrorDistrict', 'msgDistrict'],
        schoolCode: ['SCHOOL_CODE', 'hasErrorSchool', 'msgSchool'],
        gradeCode: ['GRADE_CODE', 'hasErrorGrade', 'msgGrade'],
        sourceCode: ['SOURCE_CODE', 'hasErrorSource', 'msgSource'],
        schoolYear: ['SCHOOL_YEAR', 'hasErrorSchoolYear', 'msgSchoolYear'],
        resDistrictCode: ['RES_DISTRICT_CODE', 'hasErrorResDistrict', 'msgResDistrict'],
        altSourceCode: ['ALT_SOURCE_SIS_CODE', 'hasErrorAltSource', 'msgAltSource'],
        active: ['ACTIVE', 'hasErrorActive', 'msgActive'],
        jobClassCode: ['JOB_CLASS_CODE', 'hasErrorJobClass', 'msgJobClass'],
        jobAssignment1: ['JOB_ASSIGNMENT_1', 'hasErrorJobAssign1', 'msgJobAssign1'],
        jobAssignment2: ['JOB_ASSIGNMENT_2', 'hasErrorJobAssign2', 'msgJobAssign2'],
        jobAssignment3: ['JOB_ASSIGNMENT_3', 'hasErrorJobAssign3', 'msgJobAssign3'],
        itinerantFlag: ['ITINERANT_FLAG', 'hasErrorItinerantFlag', 'msgItinerantFlag'],
      };
      if (Object.keys(ObjEsSelect).includes(field)) {
        const [code, hasError, msg] = ObjEsSelect[field];
        const isFieldRequired = field === 'districtCode' || field === 'schoolCode'
          || field === 'sourceCode' || field === 'schoolYear'
          ? this[field].length === 0
          : this.fieldRequired(code) && this[field].length === 0;
        if (isFieldRequired) {
          this[hasError] = true;
          this[msg] = `${this.fieldLabel(`${code}`)} is required.`;
        } else {
          this[hasError] = false;
          this[msg] = null;
        }
      }
    },
    validateAltIDAndAltSourceLinkage() {
      const { altPersonId, altSourceCode } = this;

      const isAltPersonIdEmpty = !altPersonId || altPersonId.trim() === '';
      const isAltSourceCodeEmpty = !altSourceCode || altSourceCode.length === 0;

      const maxLength = this.fieldLength('ALT_STUDENT_ID');
      const exceedsMaxLength = altPersonId && altPersonId.length > maxLength;

      // ALT STUDENT ID validation
      if (isAltPersonIdEmpty && !isAltSourceCodeEmpty) {
        // Only override if max length error isn't already present
        if (!exceedsMaxLength) {
          this.hasErrorAltPersonId = true;
          this.msgAltPersonId = `${this.fieldLabel('ALT_STUDENT_ID')} is required.`;
        }
      } else if (!exceedsMaxLength) {
        // Clear error only if max length is not violated
        this.hasErrorAltPersonId = false;
        this.msgAltPersonId = null;
      }

      // ALT SOURCE CODE validation
      if (!isAltPersonIdEmpty && isAltSourceCodeEmpty) {
        this.hasErrorAltSource = true;
        this.msgAltSource = `${this.fieldLabel('ALT_SOURCE_SIS_CODE')} is required.`;
      } else {
        this.hasErrorAltSource = false;
        this.msgAltSource = null;
      }

      return this.hasErrorAltPersonId || this.hasErrorAltSource;
    },
  },
};
</script>

<style lang="sass" scoped>
.border-red
  border-color: red
.control
    padding-left: 30px
.columns
    margin: 0
    display: flex
    flex-wrap: wrap
.column
    padding: 0
.control
  padding-left: 0 !important
.label
    width: 200px
.row > .field
  display: flex
  flex-wrap: wrap
  min-width: 100%
  box-sizing: border-box
  .field-label
    flex: 1
  .field-body
    flex: 2
.field-body .field .control /deep/ .control
  width: 100%
.main-column
  flex: 1 1 50%
.input
  text-overflow: ellipsis
@media screen and (max-width: 70em)
  .main-column
    flex: 1 1 100%
</style>
